var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnneagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 944.39 775.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f8f8;}.cls-2{fill:#74d5de;}.cls-12,.cls-3,.cls-5,.cls-6{fill:none;stroke-linecap:round;}.cls-3{stroke:#56cad8;}.cls-12,.cls-3,.cls-6{stroke-miterlimit:10;}.cls-3,.cls-5{stroke-width:4px;}.cls-4{fill:#56cad8;}.cls-5{stroke:#74d5de;stroke-linejoin:round;}.cls-6{stroke:#6d6d6d;stroke-width:3px;}.cls-7{fill:#fd8369;}.cls-8{fill:#333;}.cls-9{fill:#de8e68;}.cls-10{fill:#fcc486;}.cls-11{fill:#fed385;}.cls-12{stroke:#333;stroke-width:7px;}.cls-13{fill:#fed892;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hiker-man-colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264,725.66C350.18,666,514.51,578.47,671.74,518q4.18-3.74,8.5-7.54c64.42-56.95,150.43-128,160.79-205.68,10.2-77.85-55.24-162.5-135.3-208.22C625.67,51,531,44.19,436.15,44S246.28,50.13,199,101.64C151.94,153,152.62,249.69,145.48,337.91s-22.26,168.11.68,242.9C164.91,642.36,209.56,700.68,264,725.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M730.92,496.42c-8.35-2.86-35.67-39-35.67-81.89,0-49.83,52.71-144.15,57.72-177.75,3.19-21.37,17.58-209.64,126.86-209.64,59.59,0,64.56,116.51,64.56,168.62,0,121.73-177,225.42-177,288.65A270.49,270.49,0,0,1,730.92,496.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M744.36,491.9c0-97.62,72.85-275.48,136.93-338.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.68,687.41c-5.58-1.66-20.75-21-20.75-45.92,0-24,6.74-59,6.74-91.47,0-18.06-6.74-24.46-6.74-45.95,0-34.25,32.46-44.68,43.84-44.68,16.75,0,25.71,14.33,25.71,21.92,0,10.59-3,18.63-3,30.35,0,22.91,8,25.78,7.16,45.52-2.5,57.71-26.46,114.13-47.52,126.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.68,687.41c6.84-5.9-31.46-192.5-64.68-225.52C222.86,426,193.15,407,183.34,395.22c-17.4-20.89-28.48-99.67-105.07-99.67-20.26,0-68,16.75-76.59,87.64-2.81,23.27-7.92,58.87,40.51,110.46,32.62,34.76,73.42,22.79,113.3,60.45,28.71,27.11,24.69,68,51.5,102.55C228.44,684.25,284.13,721.48,323.68,687.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.28,691.86c0-46.83-147.73-258.19-206.84-288.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323.68,687.41c-1.47-11.1-7.67-105.4,9.9-139.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207,774c44.21-63.13,439.14-278.51,676.39-318.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 440.69,
    y: 112.93,
    width: 119.93,
    height: 222.98,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M451,700.49v26H380.4v-11l43.74-20.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M604.15,675.56c3.57,8,12,28.73,12,28.73l-35.23,22.15H549l-3.74-12.24,40.1-30.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 482.12,
    cy: 70.41,
    rx: 29.77,
    ry: 37.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M460.44,3.36C456.54-2,445.53-.79,435.85,6.18a33.84,33.84,0,0,0-9.16,9.67,2.68,2.68,0,0,0-1-.23c-4.7,0-82.83,41.79-82.09,61.07s26.95,50.2,36.1,56.13c0,0,41.29-19.28,39.07-25.47s-26-26-30.17-29.92c4.9-2.56,44.12-41.42,48.55-45.82A33.22,33.22,0,0,0,450,25.8C459.66,18.82,464.35,8.78,460.44,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M438,166.65c9-7.24-5.9-67.95-21.87-69.44s-43.82,28.6-42.7,37.14S415.26,184.85,438,166.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.27,312c0,10,5,356,14,386,8,4,29,5,36,2s51.67-382.52,51.67-399.18S402.27,312,402.27,312Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M581.61,687.19c-9.55-15-133.9-306.28-143.65-378.1,10.21-7.91,86.19-20.52,92.34-6.16s80,369.39,77.47,374S588.79,688.73,581.61,687.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M482.54,119c64.5,0,60.5,178.5,46.5,189.5S405.54,320,398.54,312,375,119,482.54,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M529.47,57.66c0-7.61-7.27-13.1-7.27-17.32s2.49-11.78-3.08-17.19c-6.77-6.57-17.56-3.83-27.22-3.83-9.08,0-14.09-10.55-26.48-10.55-8.26,0-7.21,10.72-10.3,13.38-2.29,2-20.14,5.84-20.14,14,0,9.12.24,21.36,19.18,21.36,1.26-4.38,6-14,11.4-18.28,2.78,1.2,18,7.48,21.77,8.59s9.28,17.25,15.12,19.2,6.21,12.7,10.48,12.24S529.47,77,529.47,57.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 507.75,
    cy: 73.37,
    r: 7.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M497,133c-1.26,4.35-27.71-.93-27.2-5.85l4.52-43.7,31.87,6.86S498.28,128.67,497,133Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 677.16,
    y1: 156.44,
    x2: 565.31,
    y2: 710.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M659.22,309.44a20.39,20.39,0,0,0-11-5.75c-13.34-21.53-58.67-87.89-78.66-112-14.41,10.35-32,28.45-32,28.45,7.35,8.24,62.4,73.37,91.69,98.91a19.91,19.91,0,0,0,6,14.37c7.41,7.42,18.79,8.06,25.41,1.45S666.63,316.86,659.22,309.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M507.87,148.25c25.87-19.23,68.52,27.27,67.82,39.5S542.21,227.1,531,227.13C517.31,227.15,485.85,164.62,507.87,148.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnneagram);
export default __webpack_public_path__ + "static/media/enneagram.8e88f095fab5694bf2da8b29f93ed93a.svg";
export { ForwardRef as ReactComponent };